import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

// Renders admin-managed SEO content (intro + main body) and a VISIBLE FAQ
// accordion. The FAQ shown here is exactly what FAQPage structured data emits
// on the backend — so schema always mirrors visible content.
export const SeoContentBlock = ({ intro, content, faqs, testidPrefix = 'seo' }) => {
  const list = Array.isArray(faqs) ? faqs.filter(f => (f?.q || f?.question) && (f?.a || f?.answer)) : [];
  if (!intro && !content && list.length === 0) return null;
  return (
    <div className='mt-10 space-y-6' data-testid={`${testidPrefix}-content-block`}>
      {intro && (
        <div
          className='indus-prose max-w-none text-muted-foreground text-[15px] leading-7'
          data-testid={`${testidPrefix}-intro`}
          dangerouslySetInnerHTML={{ __html: intro }}
        />
      )}
      {content && (
        <div
          className='indus-prose max-w-none text-[15px] leading-7'
          data-testid={`${testidPrefix}-content`}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
      {list.length > 0 && (
        <div data-testid={`${testidPrefix}-faq`}>
          <h2 className='text-lg font-semibold mb-2'>Frequently asked questions</h2>
          <Accordion type='single' collapsible className='w-full'>
            {list.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} data-testid={`${testidPrefix}-faq-item-${i}`}>
                <AccordionTrigger className='text-left text-sm'>{f.q || f.question}</AccordionTrigger>
                <AccordionContent className='text-sm text-muted-foreground'>{f.a || f.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      )}
    </div>
  );
};

export default SeoContentBlock;
